import { INavigation } from "./navigation.types"

export const NAVIGATION_DATA = (): INavigation => {
    return {
        user: [
            {
                id: 'my_assets',
                label: 'navigation.myAssets',
                img: "./assets/img/Icon/Icon-Assets.svg",
                isExpanded: true,
                children: [
                    {
                        id: "kryptomons",
                        label: "navigation.kryptomons",
                        img: "./assets/img/Icon/Icon-Cards.svg",
                        target: '/kryptomons'
                    },
                    {
                        id: "items",
                        label: "navigation.items",
                        img: "./assets/img/Icon/Icon-Items.svg",
                        // target: '/items'
                        target: '/assets'

                    },
                    {
                        id: "wallet",
                        label: "navigation.wallet",
                        img: "./assets/img/Icon/Icon-KMON.svg",
                        target: '/wallet'
                    },
                    {
                        id: "breeding-center",
                        label: "navigation.breedingCenter",
                        img: "./assets/img/Icon/Icon-Breeding-Light.svg",
                        // target: '/breeding-center'
                        target: '/breeding'
                    }
                ]
            },
            {
                id: "rewards",
                label: 'navigation.rewards',
                img: "./assets/img/Icon/Icon-Reward.svg",
                isExpanded: true,
                children: [
                    // {
                    //     id: "binance-nft",
                    //     label: "navigation.kryptomons",
                    //     img: "./assets/img/Icon/Binance.png",
                    //     target: '/bbbbb'
                    // },
                    {
                        id: "spin-the-wheel",
                        label: "navigation.spinTheWheel",
                        img: "./assets/img/Icon/clover.png",
                        target: '/spin-the-wheel'
                    },
                    {
                        id: "staking",
                        label: "navigation.staking",
                        img: "./assets/img/Icon/Icon-Staking.svg",
                        target: '/staking'
                    },
                    {
                        id: "referral",
                        label: "navigation.referral",
                        img: "./assets/img/Icon/Icon-Gift.svg",
                        target: '/referral'
                    },
                    {
                        id: "claim-reward",
                        label: "navigation.claimReward",
                        img: "./assets/img/Icon/Icon-Reward-Star.svg",
                        // target: '/claim-reward'rewards-claim
                        target: '/rewards-claim'
                    },
                ]
            },
            {
                id: "marketplace",
                label: 'navigation.marketplace',
                img: "./assets/img/Icon/Icon-Marketplace.svg",
                isExpanded: true,
                children: [
                    {
                        id: "marketplace-kryptomons",
                        label: "navigation.kryptomons",
                        img: "./assets/img/Icon/Icon-Cards.svg",
                        // target: '/marketplace-kryptomons'
                        target: '/marketplace'
                    },
                    {
                        id: "auction-house",
                        label: "navigation.auctionHouse",
                        img: "./assets/img/Icon/Icon-Auction.svg",
                        // target: '/auction-house'
                        target:'/shop/browseItem/'
                    },
                    {
                        id: "renting-house",
                        label: "navigation.rentingHouse",
                        img: "./assets/img/Icon/Logo-Playdex.svg",
                        target: '/renting-house'
                    },
                ]
            },
            {
                id: "shop",
                label: 'navigation.shop',
                img: "./assets/img/Icon/Icon-Shop.svg",
                isExpanded: true,
                children: [
                    {
                        id: "primus-bazar",
                        label: "navigation.primusBazar",
                        img: "./assets/img/Icon/Icon-PrimeBazaar.svg",
                        // target: '/primus-bazar'
                        target: '/shop'
                    },
                    {
                        id: "merchandise",
                        label: "navigation.merchandise",
                        img: "./assets/img/Icon/Icon-Merchandise.svg",
                        target: '/merchandise'
                    },
                ]
            },
            {
                id: "resources",
                label: 'navigation.resources',
                img: "./assets/img/Icon/Icon-Guide.svg",
                isExpanded: true,
                children: [
                    {
                        id: "communities",
                        label: "navigation.communities",
                        img: "./assets/img/Icon/Icon-Communities.svg",
                        target: '/communities'
                    },
                    {
                        id: "academy",
                        label: "navigation.academy",
                        img: "./assets/img/Icon/Icon-Academy.svg",
                        target: '/academy'
                    },
                ]
            }
        ]
    }

}
